import { Component } from '@angular/core';
import {
  Checkout,
  Membership,
  Overview,
  Purchase
} from '@com-delta-idp/mnx-sky-club-ui';
import { StateFacade } from '../../data-access/facades/state.facade';
import { PURCHASE_CART_URL } from '../../data-access/models';
import { DataLayerAnalyticsService } from '../../data-access/services/analytics/data-layer.service';
import { getPreviousPageDetails } from '../../data-access/utils/analytics.utils';

@Component({
  selector: 'idp-sky-club',
  templateUrl: './sky-club.component.html',
  styleUrls: ['./sky-club.component.scss']
})
export class SkyClubComponent {
  emptyOverview: Overview = {} as Overview;
  emptyPurchase: Purchase = {} as Purchase;
  emptyCheckout: Checkout = {} as Checkout;
  selectedMembershipType = 'executive';

  constructor(
    public skyClub: StateFacade,
    public dataLayer: DataLayerAnalyticsService
  ) {
    this.dataLayer.pageLoadStart = Date.now();
    skyClub.init();
  }

  redirect(url: string, type: string) {
    window.open(url, type === 'link' ? '_blank' : '_self');
  }

  private getMembershipTierFromLevel(membershipLevel: string): string {
    const levelMap: { [key: string]: string } = {
      FO: 'Silver',
      GM: 'Gold',
      PM: 'Platinum',
      DM: 'Diamond',
      DM360: 'Diamond'
    };
    return levelMap[membershipLevel] || '';
  }

  private getMembershipTierFromDesc(medallionDesc: string): string {
    const parts = medallionDesc.split(' ');
    return parts.length > 1 ? parts[0] : medallionDesc;
  }

  private getMembershipTier(purchase: Purchase): string {
    if (purchase.membershipLevel) {
      return this.getMembershipTierFromLevel(purchase.membershipLevel);
    }
    if (purchase.medallionMemberDesc) {
      return this.getMembershipTierFromDesc(purchase.medallionMemberDesc);
    }
    return '';
  }

  private getMembershipType(description: string): string {
    return description.toLowerCase().includes('executive')
      ? 'executive'
      : 'individual';
  }

  addToCart(membership: Membership, purchase: Purchase) {
    const membershipType = this.getMembershipType(
      membership.detail.membershipDescription
    );
    const membershipTier = this.getMembershipTier(purchase);
    this.selectedMembershipType = membershipType;

    this.dataLayer.clickCTA(
      'add to cart',
      'add to cart',
      'button',
      `one-year ${membershipType} membership:add to cart`,
      { membershipType, membershipTier }
    );

    this.skyClub.addToCart(membership);
  }

  checkOut(purchase: Purchase) {
    const membershipTier = this.getMembershipTier(purchase);

    this.dataLayer.clickCTA(
      'checkout',
      'check out now',
      'button',
      `one-year ${this.selectedMembershipType} membership:check out now`,
      {
        membershipType: this.selectedMembershipType,
        membershipTier: membershipTier
      }
    );
    location.href = PURCHASE_CART_URL;
  }

  previousButton() {
    const previousPageName = getPreviousPageDetails().name || 'previous page';
    this.dataLayer.clickCTA(
      'previous',
      'previous',
      'button',
      `Return to ${previousPageName}`
    );
    location.reload();
  }

  returnToSkyClub() {
    const previousPageName = getPreviousPageDetails().name || 'previous page';
    this.dataLayer.clickCTA(
      ' Return to Delta Sky Club Page',
      'Return to Delta Sky Club Page',
      'link',
      `Return to ${previousPageName}`
    );
  }
}
